import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeartPulse = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M25.3334 18.6667C27.3201 16.72 29.3334 14.3867 29.3334 11.3333C29.3334 9.38841 28.5608 7.52315 27.1855 6.14788C25.8103 4.77262 23.945 4 22.0001 4C19.6534 4 18.0001 4.66667 16.0001 6.66667C14.0001 4.66667 12.3467 4 10.0001 4C8.05516 4 6.1899 4.77262 4.81463 6.14788C3.43937 7.52315 2.66675 9.38841 2.66675 11.3333C2.66675 14.4 4.66675 16.7333 6.66675 18.6667L16.0001 28L25.3334 18.6667Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.29321 15.9997H12.6665L13.3332 14.6663L15.9999 20.6663L18.6665 11.333L20.6665 15.9997H27.6932",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgHeartPulse);
export default ForwardRef;
